/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */
import { AuthApi } from "../api/Auth.api";
import { MailApi } from "../api/Mail.api";
import { UserApi } from "../api/User.api";
import { UserDataApi } from "../api/UserData.api";
import { Action } from "../models/Action.model";
import { Company } from "../models/Company.model";
import { User } from "../models/User.model";
import { UserData } from "../models/UserData.model";
import { JsonApiService } from "../utils/json-api";

export class ApiService extends JsonApiService {

    public auth: AuthApi = new AuthApi(this);
    public user: UserApi = new UserApi(this);
    public userData: UserDataApi = new UserDataApi(this);
    public mail: MailApi = new MailApi(this);

    constructor() {
        super();
        this
            .registerModel(User.TYPE, User)
            .registerModel(UserData.TYPE, UserData)
            .registerModel(Action.TYPE, Action)
            .registerModel(Company.TYPE, Company)
            ;
    }

}



// WEBPACK FOOTER //
// ./src/services/Api.service.ts